var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_c('img',{attrs:{"src":require("@static/images/noData.png"),"alt":""}})]),_c('div',[_c('span',[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }